import './style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { IconName, findIcon } from 'utils/handleIcon';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { PagePath } from 'constants/pagePath';
import { useNavigate } from 'react-router-dom';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
import { useCustomLocationName } from 'views/mutual/location/hooks';

export type DomesticRealEstateItExplanationImpossibleProps = {
    symbolDetail: DomesticRealEstateSymbolDetailInfo;
  };

export const DomesticRealEstateItExplanationSymbolApplyImpossible = ({symbolDetail}: DomesticRealEstateItExplanationImpossibleProps) => {
  const navigate = useNavigate();
  useCustomLocationName(symbolDetail.ProductName!);
  return (
    <>
      <div className="domesticRealEstateItExplanation-symbolApplyImpossible">
        <div className="domesticRealEstateItExplanation-symbolApplyImpossible_descriptionWrapper">
          <Description
            label="恐れ入りますが、取引を希望される場合は最寄りの営業拠点にお問い合わせください"
            labelColor={labelColor.gray}
            labelSize={labelSize.medium}
          />
        </div>
        <Button
          label="HOMEに戻る"
          buttonFill={ButtonFill.link}
          buttonSize={ButtonSize.small}
          onClick={() => navigate(PagePath.Home)}
        />
      </div>
    </>
  );
};
